import { bool, string, func } from 'prop-types';
import { QUICK_LINKS_PAGE_URL } from 'src/constants/urlConstants';
import {
  StyledLogoLinkContainer,
  StyledLogo,
  StyledLogoContainer,
} from './styles';

export const HeaderLogo = ({ isAgencyStatusApproved, logoUrl, t }) =>
  isAgencyStatusApproved ? (
    <StyledLogoLinkContainer
      to={QUICK_LINKS_PAGE_URL}
      label="Header Logo"
      dataTest="header logo test"
    >
      <StyledLogo
        src={logoUrl}
        alt={`${t('subAgentHeader.accounts')} icon`}
        link
      />
    </StyledLogoLinkContainer>
  ) : (
    <StyledLogoContainer>
      <StyledLogo src={logoUrl} alt={`${t('subAgentHeader.accounts')} icon`} />
    </StyledLogoContainer>
  );

HeaderLogo.propTypes = {
  isAgencyStatusApproved: bool.isRequired,
  logoUrl: string.isRequired,
  t: func.isRequired,
};
